import Vue from 'vue';
import { recognition } from 'mycorems-app-accounts';

export const AccountContextMixin = Vue.extend({
  props: {
    accountId: {
      type: String,
      default() {
        return recognition.getAccountId();
      },
    },
  },
});

export const UserContextMixin = Vue.extend({
  props: {
    userId: {
      type: String,
      default() {
        return recognition.getUserId();
      },
    },
  },
});

export const HasTaskMixin = Vue.extend({
  data(): { task: Promise<any>|null, isLoading: boolean } {
    return {
      task: null,
      isLoading: false,
    };
  },
  watch: {
    task(task: Promise<any>) {
      this.isLoading = true;
      task.finally(() => {
        this.isLoading = false;
      });
    },
  },
});

export const PaginationMixin = Vue.extend({
  props: {
    total: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 20,
    },
    size: {
      type: String,
      default: '1rem',
    },
  },
  computed: {
    numPages(): number {
      return Math.ceil(this.total / this.perPage);
    },
    start(): number {
      return ((this.value - 1) * this.perPage) + 1;
    },
    end(): number {
      const end = this.start + (this.perPage - 1);
      return (end > this.total) ? this.total : end;
    },
    offset(): number {
      return (this.value - 1) * this.perPage;
    },
  },
  methods: {
    prevPage(): void {
      this.changePage(this.value - 1);
    },
    nextPage(): void {
      this.changePage(this.value + 1);
    },
    changePage(newPage: number): void {
      this.$emit('input', newPage);
    },
  },
});

export const AccountDashboardMixin = Vue.extend({
  computed: {
    styles(): object {
      return (this.isLaptopOrDesktop) ? { 'margin-top': '3.5rem' } : { 'margin-top': '1rem' };
    },
    isMobileOrTablet(): boolean {
      return (this.$q.screen.lt.lg);
    },
    isLaptopOrDesktop(): boolean {
      return (this.$q.screen.gt.md);
    },
  },
});
